import { defineStore } from 'pinia'
import { useConstants } from '~/composables/constants'

export const useUserStore = defineStore('user', {
  state: () => ({
    isLoggedIn: false,
    isAdmin: false,
    email: '',
    name: '',
    designIds: [] as string[],
    isLoading: false
  }),

  getters: {
    getIsLoggedIn: (state) => state.isLoggedIn,
    getEmail: (state) => state.email,
    getDesignIds: (state) => state.designIds,
    getIsLoading: (state) => state.isLoading,
    isInternalUser: (state) => {
      const email = state.email?.toLowerCase() || ''
      return email.endsWith('@feltright.com') || email.endsWith('@gsdtechsolutions.com')
    },
  },

  actions: {
    async login(email: string) {
      this.isLoading = true
      const normalizedEmail = email.trim().toLowerCase()
      this.isAdmin = normalizedEmail.endsWith('@feltright.com')
      try {
        const response = await fetch('/api/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ email }),
        })

        if (response.ok) {
          const data = await response.json();
          this.designIds = data.designIds;
          this.email = normalizedEmail;
          this.isLoggedIn = true
          setCookie(useConstants().FELT_RIGHT_USER_COOKIE, normalizedEmail);
          return true
        }
        return false
      } catch (error) {
        console.error('Login failed:', error)
        return false
      } finally {
        this.isLoading = false
      }
    },

    logout() {
      this.isLoggedIn = false
      this.isAdmin = false
      this.email = ''
      this.name = ''
      this.designIds = []
      deleteCookie(useConstants().FELT_RIGHT_USER_COOKIE)
    },

    async fetchDesigns(page = 1) {
      if (!this.isLoggedIn || !this.email) throw new Error("User must be logged in")

      const list = await GET(`/api/designs?userId=${this.email}&page=${page}`)

      return list
    },

    async initializeFromCookie() {
      const userEmail = getCookie(useConstants().FELT_RIGHT_USER_COOKIE)
      if (userEmail) {
        this.email = userEmail.trim().toLowerCase()
        this.isLoggedIn = true
        this.isAdmin = this.email.endsWith('@feltright.com')
        await this.login(this.email)
      }
    }
  }
})
